import React from "react";
import time from "src/utils/time";
import { Flex } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { Subtitle } from "src/atoms/typography";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as TimeIcon } from "./time.svg";

const INITIAL_UPDATE_INTERVAL_IN_MS = 1000 * 5;
const UPDATE_INTERVAL_IN_MS = 1000 * 29;
const ONE_MINUTE = 60 * 1000;

class MonitoringTimer extends React.Component {
  state = {
    monitoringTime: null
  };
  updateInterval = INITIAL_UPDATE_INTERVAL_IN_MS;

  componentDidMount() {
    this.intervalId = setInterval(
      this.updateMonitoringTime,
      INITIAL_UPDATE_INTERVAL_IN_MS
    );
    this.updateMonitoringTime();
  }
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }
  updateMonitoringTime = () => {
    const { monitoringStartTime, t } = this.props;
    const monitoringDuration = time.duration(
      time().diff(time(monitoringStartTime))
    );
    const monitoringTime =
      monitoringDuration.asMilliseconds() > ONE_MINUTE
        ? monitoringDuration.format("d _ h _ m _")
        : t("parentStation.monitoringTimer.lessThanMinute");

    this.setState({ monitoringTime });

    if (
      this.updateInterval === INITIAL_UPDATE_INTERVAL_IN_MS &&
      monitoringDuration > ONE_MINUTE
    ) {
      clearInterval(this.intervalId);
      this.intervalId = setInterval(
        this.updateMonitoringTime,
        UPDATE_INTERVAL_IN_MS
      );
      this.updateInterval = UPDATE_INTERVAL_IN_MS;
    }
  };

  render() {
    const { monitoringTime } = this.state;
    const { isDarkMode } = this.props;

    return (
      <Flex alignItems="center">
        <SvgContainer
          fill={isDarkMode ? "white" : "black"}
          icon={TimeIcon}
          size={["18px", "24px", "28px"]}
        />
        <Subtitle
          ml={["4px", "6px", "8px"]}
          fontSize={["14px", "18px", "22px"]}
          color={isDarkMode ? "white" : "black"}
        >
          {monitoringTime}
        </Subtitle>
      </Flex>
    );
  }
}

export default withTranslation()(MonitoringTimer);
